import React, { useEffect } from "react";
import ImageGallery from "react-image-gallery";
import "./styles/image-gallery.css";

/**
 * A photo container for the ImageGallery plugin
 * the plugin has its own css file (image-gallery.css) that was manually altered to fit the project
 */

const Carousel = ({ images, showThumbnails, showBullets }) => {
    useEffect(() => {
        const handler = (e) => {
            if (e.target.tagName === "IMG") {
                e.preventDefault();
            }
        };

        document.addEventListener("dragstart", handler);
        return () => {
            document.removeEventListener("dragstart", handler);
        };
    }, []);

    return (
        <ImageGallery
            items={images}
            showPlayButton={false}
            useBrowserFullscreen={true}
            showThumbnails={showThumbnails}
            showBullets={showBullets}
        />
    );
};

export default Carousel;
